<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="16">
        <a-form layout="inline">
          <a-form-item>
            <a-select v-model="org_id" placeholder="机构" style="width: 100px;" :loading="loading">
              <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="campus_id" placeholder="校区" style="width: 140px;" width="200px;" @change="changeCampus"
              :loading="loading">
              <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
			 
            <a-select v-model="squad_id" placeholder="班级" style="width:200px" @change="changeSquad" allow-clear>
              <a-select-option v-for="(item) in squadList" :key="item.id" :value="item.id">{{ item.gradename }} /
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-input v-model="keyword" placeholder="名字、电话"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="getTableList"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col></a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="datalist" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="username" title="学生名字" data-index="username" />
        <a-table-column key="mobile" title="学生电话" data-index="mobile" />
        <a-table-column key="jion_time" title="进班时间">
          <template slot-scope="item">
            <span>{{ moment(item.jion_time * 1000).format('ll') }}</span>
          </template>
        </a-table-column>
        <a-table-column key="opt" title="操作">
          <template slot-scope="item">
            <student-home-work :user_id="item.id" :squad_id="squad_id" />
            <!--<a-button type="primary" htmlType="submit" icon="ordered-list" @click="showHomeWorkInfo(item.id)" >查看作业</a-button>-->
          </template>
        </a-table-column>
      </a-table>
    </div>

  </or-layout>
</template>

<script>

import ACol from "ant-design-vue/es/grid/Col";
import moment from "moment";
import StudentHomeWork from "../components/show_student_homework.vue";

export default {
  components: { ACol, StudentHomeWork },
  data() {
    return {
      keyword: undefined,
      homework_visible: false,
      video_path: undefined,
      video_visible: false,
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      loading: false,
      source_type: "mryl",
      media_path: "",
      datalist: [],
      orgList: [],
      org_id: undefined,
      campusList: [],
      squadList: [],
      campus_id: undefined,
      squad_id: undefined,
    };
  },
  mounted() {
    this.loading = true;
    // this.getTableList();
    this.getMyOrgList();

  },
  methods: {
    changeMissionType() {
      this.loading = true;
      this.$axios
        .post("/api/StudentHomeWork/get_student_homework", {
          data: {
            squad_id: this.squad_id,
            user_id: this.curr_user_id,
            type_id: this.curr_mission_type
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.homeworkList = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showHomeWorkInfo(user_id) {
      this.curr_user_id = user_id;
      this.changeMissionType();
      this.homework_visible = true;
    },
    changeSquad(id) {
      this.squad_id = id;
      this.keyword = undefined;
      this.getTableList();
    },
    changeCampus(id) {
      this.campus_id = id;
      this.getMySquadList();
    },
    show_video(url) {
      this.media_path = url;
      this.video_visible = true;
    },
    onPaginationChange(page) {
      this.pageinfo.current = page.current;
      this.getTableList();
    },
    tableSearch() {
      this.pageinfo.current = 1;
      this.getTableList();
    },
    getTableList() {
      this.loading = true;
      this.$axios
        .post("/api/user/index", {
          data: {
            squad_id: this.squad_id,
            keyword: this.keyword
          }, pageinfo: this.pageinfo
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.datalist = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    change_audit(data) {
      this.loading = true;
      this.$axios
        .post("/api/StudentLecture/change_audit", { data })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.getTableList();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getMyOrgList() {
      this.$axios
        .post("/api/Admin/get_my_org_list")
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgList = res.data;
            if (this.orgList.length > 0) {
              this.org_id = this.orgList[0]['id'];
              this.getMyCampusList();
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getMyCampusList() {
      this.$axios
        .post("/api/Admin/get_my_campus_list", {
          data: { org_id: this.org_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data;
            if (this.campusList.length > 0) {
              this.campus_id = this.campusList[0]['id'];
              this.getMySquadList();
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getMySquadList() {
      this.$axios
        .post("/api/Admin/get_my_squad_list", {
          data: { campus_id: this.campus_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadList = res.data;
            if (this.squadList.length > 0) {
              this.squad_id = this.squadList[0]['id'];
              this.changeSquad(this.squad_id)
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    moment
  }
}
  ;
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>